export default {
    namespaced: true,
    state: {
        currentCategoryId: null,
        currentType: null
    },
    mutations: {
        // SET_CURRENT_CATEGORY_ID(state, id) {
        //     state.currentCategoryId = id;
        // }

    },
    actions: {

    }
}